export const lineChartConfig = {
  chart: {
    height: 350,
    margin: [10, 40, 70, 65]
  },

  title: {
    text: ''
  },

  legend: {
    layout: 'horizontal',
    align: 'center',
    verticalAlign: 'bottom',
    backgroundColor: '#FFFFFF',
    margin: 16,
    floating: false,
    x: 0,
    y: 0,
  },

  yAxis: {
    allowDecimals: false,
    title: {
      text: null,
    },
    minRange: 1
  },

  xAxis: {
    type: 'datetime',
    dateTimeLabelFormats: {
      day: '%m/%d',
    },
    minPadding: 0.05,
    maxPadding: 0.05,
    minorTickLength: 0,
    tickLength: 0,
    labels: {
      y: 25,
    },
  },

  plotOptions: {
    series: {
      label: {
        connectorAllowed: true,
      },
      pointStart: 2010,
    },
  },

  credits: {
    enabled: false,
  },
}

export const barChartConfig = {
  chart: {
    type: 'column',
    height: 350,
    margin: [10, 40, 70, 65]
  },
  title: {
    text: ''
  },
  yAxis: {
    allowDecimals: false,
    min: 0,
    title: {
      text: ''
    }
  },
  credits: {
    enabled: false,
  },
  plotOptions: {
    column: {
      stacking: 'normal'
    }
  }
}